module.exports = __webpack_public_path__ + "img/stellini_loader.7bd64cf4.svg";